import { ModalContentProps } from "modals/content/types";
import { Component } from "react";
import { connect } from "react-redux";
import { AppState } from "types/app";
import "./ModalContent.css";

const mapStateToProps = (state:AppState):ModalContentProps.Redux => {
	return {
		lang: state.userInfo.options.lang,
		gameLang: state.userInfo.options.gameLang,
	};
};

class ModalContent extends Component<ModalContentProps.Component> {
	render():JSX.Element{
		return (
			<div className="modal-content">
				{this.props.children}
			</div>
		);
	}


}
export default connect(mapStateToProps)(ModalContent);
